import React, { useState } from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function ContactForm() {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    relationship: 'parent',
    musicianName: '',
    musicianAge: '',
    instrument: '',
    experience: '',
    accommodations: '',
    message: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    // We don't prevent the default submission
    // Just update our local state for UI purposes
    setTimeout(() => {
      setFormSubmitted(true);
    }, 100);
    // The form will submit naturally to Formspark via the action attribute
  };
  return <section id="contact" className="py-20 bg-indigo-50" data-id="element-40">
      <div className="container mx-auto px-4" data-id="element-41">
        <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-42">
          <div className="p-8 md:p-12" data-id="element-43">
            <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center" data-id="element-44">
              Join Our Music Collective
            </h2>
            <p className="text-gray-600 mb-8 text-center" data-id="element-45">
              Interested in joining? Fill out this interest form to signal your
              support!
            </p>
            {formSubmitted ? <div className="text-center py-12" data-id="element-46">
                <CheckCircleIcon size={64} className="text-green-500 mx-auto mb-6" data-id="element-47" />
                <h3 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-48">
                  Thank You!
                </h3>
                <p className="text-gray-600" data-id="element-49">
                  Your information has been submitted successfully. We'll keep
                  you updated as we work to establish this program.
                </p>
              </div> : <form action="https://submit-form.com/yoOGIeKTZ" method="POST" onSubmit={handleSubmit} data-id="element-50">
                <div className="grid md:grid-cols-2 gap-6 mb-6" data-id="element-51">
                  <div data-id="element-52">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-53">
                      Your Name *
                    </label>
                    <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500" required data-id="element-54" />
                  </div>
                  <div data-id="element-55">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-56">
                      Email Address *
                    </label>
                    <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500" required data-id="element-57" />
                  </div>
                </div>
                <div className="grid md:grid-cols-2 gap-6 mb-6" data-id="element-58">
                  <div data-id="element-59">
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-60">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500" data-id="element-61" />
                  </div>
                  <div data-id="element-62">
                    <label htmlFor="relationship" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-63">
                      Your Relationship to Musician *
                    </label>
                    <select id="relationship" name="relationship" value={formData.relationship} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500" required data-id="element-64">
                      <option value="parent" data-id="element-65">Parent</option>
                      <option value="self" data-id="element-66">Self (I am the musician)</option>
                      <option value="caregiver" data-id="element-67">Caregiver</option>
                      <option value="family" data-id="element-68">Family Member</option>
                      <option value="professional" data-id="element-69">Professional Support</option>
                      <option value="other" data-id="element-70">Other</option>
                    </select>
                  </div>
                </div>
                <div className="grid md:grid-cols-2 gap-6 mb-6" data-id="element-71">
                  <div data-id="element-72">
                    <label htmlFor="musicianName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-73">
                      Musician's Name *
                    </label>
                    <input type="text" id="musicianName" name="musicianName" value={formData.musicianName} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500" required data-id="element-74" />
                  </div>
                  <div data-id="element-75">
                    <label htmlFor="musicianAge" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-76">
                      Musician's Age *
                    </label>
                    <input type="text" id="musicianAge" name="musicianAge" value={formData.musicianAge} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500" required data-id="element-77" />
                  </div>
                </div>
                <div className="mb-6" data-id="element-78">
                  <label htmlFor="instrument" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-79">
                    Instrument(s) Played *
                  </label>
                  <input type="text" id="instrument" name="instrument" value={formData.instrument} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500" required data-id="element-80" />
                </div>
                <div className="mb-6" data-id="element-81">
                  <label htmlFor="experience" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-82">
                    Musical Experience Level *
                  </label>
                  <input type="text" id="experience" name="experience" value={formData.experience} onChange={handleChange} placeholder="E.g., 3 years of piano lessons, plays guitar by ear, etc." className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500" required data-id="element-83" />
                </div>
                <div className="mb-6" data-id="element-84">
                  <label htmlFor="accommodations" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-85">
                    Any Accommodations Needed
                  </label>
                  <input type="text" id="accommodations" name="accommodations" value={formData.accommodations} onChange={handleChange} placeholder="Please share any accommodations that would help the musician participate fully" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500" data-id="element-86" />
                </div>
                <div className="mb-6" data-id="element-87">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-88">
                    Additional Information
                  </label>
                  <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500" data-id="element-89"></textarea>
                </div>
                {/* Honeypot field to prevent spam */}
                <input type="text" name="_honeypot" style={{
              display: 'none'
            }} data-id="element-90" />
                {/* Add a redirect URL for Formspark */}
                <input type="hidden" name="_redirect" value={window.location.href} data-id="element-91" />
                <div className="text-center" data-id="element-92">
                  <button type="submit" className="bg-indigo-600 text-white px-8 py-3 rounded-md font-medium hover:bg-indigo-700 transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" data-id="element-93">
                    Submit Interest Form
                  </button>
                </div>
              </form>}
          </div>
        </div>
      </div>
    </section>;
}